export const storyboard__experience = [
    {
        id: 0,
        title: "journey so far",
        content: ["started in 2015, @ cognizant - a leading corporation in india","bagged multiple awards troughout 2016-2018", "in 2018, tranistion to independent consultation","collaboration with leaders of the industry","remote working with teams to create digital solutions","mentoring young engineers"]
    },
    {
        id: 1,
        title: "skills and finesse",
        content: ["design and cloud development", "ability to stimulate outcomes","ability to break down details into executable and measurable tasks","freerunning, and","mountain climbling"]
    },
    {
        id: 2,
        title: "personality traits",
        content: ["team player first","often contributes to open source libraries","works hard and parties even harder","believes micheal bisping is the best middleweight of all time", "listens to 90’s music.. a lot"]
    }
] 

export const services = "\"..nothing is static. everything is evolving. everything is falling apart\" - Tyler durden"
export const services__description = [
    {
        header: "infrastructure services",
        description: "Lorem Ipsum is simply dummy text of the dummy ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        services: ["Infrastructure as a Code", "Container Orchestration", "CI/CD Pipelines", "Version Control Strategy", "Configuration Management", "Cloud Security"]  
    }, 
    {
        header: "Software & Digital Solutions",
        description: "Scrambled it to make a type specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type",
        services: ["Identity Solutions", "Datawarehousing Solutions", "Payment Solutions", "SDK Solutions", "Storage Solutions", "Compute Solutions"]
    }, 
    {
        header: "product development",
        description: "industry's standard dummy text ever since the 1500s, when an unknown printer took a gallery of type and scrambled it to make a type specimen book.",
        services: ["Product strategy", "UX and UI design", "Frontend development", "Backend development", "Testing and Quality Assurance", "Support and Maintenance"]
    }
]

export const call_to_action = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"